<template>
  <v-form @submit.prevent="onSubmit">
    <v-card>
      <v-card-title>
        {{ formTitle }}
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" md="4">
            <BaseDatepickerInput
              v-model="machineryInspection.date"
              :error-messages="errors['date']"
              :label="formMixin_getRequiredFieldLabel($t('date'))"
              :clearable="false"
              @input="formMixin_clearErrors('date')"
            />
          </v-col>

          <v-col cols="12">
            <v-textarea
              v-model="machineryInspection.comments"
              :error-messages="errors['comments']"
              :label="$t('comments')"
              rows="1"
              autofocus
              auto-grow
              @input="formMixin_clearErrors('comments')"
            />
          </v-col>

          <v-col cols="12">
            <v-file-input
              v-model="machineryInspection.documents"
              :error-messages="documentErrors"
              :label="$t('attach_files')"
              :accept="acceptedFileFormats"
              multiple
              chips
              small-chips
              @input="formMixin_clearErrors('documents')"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <span v-if="!machineryInspection.id" class="subtitle-2 ml-3">
          * {{ $t('must_be_filled') }}
        </span>

        <v-spacer />

        <v-btn color="primary" text @click.native="$emit('cancel')">
          {{ $t('cancel') }}
        </v-btn>

        <v-btn
          :disabled="isRequestPending"
          :loading="isRequestPending"
          type="submit"
          color="primary"
          text
        >
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import crudMixin from '../../mixins/crud-mixin';
import dialogMixin from '../../mixins/dialog-mixin';
import formMixin from '../../mixins/form-mixin';
import machineryInspectionService from '@/api/machinery-inspection-service';
import BaseDatepickerInput from '@/components/base/BaseDatepickerInput';

export default {
  name: 'MachineryInspectionForm',

  components: { BaseDatepickerInput },

  mixins: [crudMixin, dialogMixin, formMixin],

  props: {
    formItem: Object,
    acceptedFileFormats: {
      type: String,
      default: '*',
    },
  },

  data() {
    return {
      errors: {},
      isRequestPending: false,
      machineryInspection: {},
    };
  },

  computed: {
    formTitle() {
      return this.$t(
        this.machineryInspection.id ? 'edit_machinery_inspection' : 'new_machinery_inspection',
      );
    },

    documentErrors() {
      let documentErrors = [];
      Object.keys(this.errors).forEach(error => {
        if (!error.includes('documents')) {
          return;
        }
        documentErrors = [...documentErrors, ...this.errors[error]];
      });
      return documentErrors;
    },
  },

  methods: {
    onDialogOpen() {
      this.machineryInspection = JSON.parse(JSON.stringify(this.formItem));
      this.machineryInspection.documents = [];
      if (!this.machineryInspection.id) {
        // TODO presetting date makes it so changing it doesn't update the view. Find a fix
        // this.machineryInspection.date = format(new Date(), 'yyyy-MM-dd');
      }
      this.errors = {};
    },

    onSubmit() {
      this.crudMixin_createOrUpdate(machineryInspectionService, this.machineryInspection);
    },
  },
};
</script>
